export default "__VITE_ASSET__DJSq0XBw__"